<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import store from './store';
export default {
  name: 'App',
  store,
};
</script>

<style lang="scss">
#q-app {
  background: #e5e5e5;
}

// Global App Styles
#q-app {
  color: $neutral-1-900; // Set default text color
}

// Quasar Button Icon Size
.q-btn .q-icon {
  font-size: 18px;
}

// Quasar Chips
.q-chip__icon {
  font-size: 14px;
}

.q-chip__icon--left {
  margin-right: 8px;
}

.top-bar {
  .q-chip__content {
    margin-right: 8px; // Give extra spacing to text content in user-added tags in scan header (.top-bar)
  }
}

.q-chip__icon--remove {
  font-size: 16px;
}
</style>
